import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import bem from 'utils/bem';
import Top from './Top';
import Project from './Project';
import FrontFeedbackFormBlock from './FrontFeedbackFormBlock';
import Consultations from './Consultations';
import Specialists from './Specialists';
import Shop from './Shop';
import Mediatek from './Mediatek';
import './index.sass';
import Model from '../../../model';

const { block, el } = bem('front')

const Front = () => {
    const { openFinishPaymentModal } = Model.modal;
    const { state } = useLocation();

    useEffect(() => {
        if ( state?.response ) {
            const { response } = state;
            if ( response.error ) {
                toast.error( `Ошибка при проверке статуса оплаты: ${ response?.error_text }`);
            }
            if ( response.success ) {
                openFinishPaymentModal(response);
            } else {
                toast.error( `${ response.status }: ${ response.text_status }`);
            }
        }
    }, [state]);

    return (
        <div className={ block() }>
            <Top/>
            <div className={ el('rest') }>
                <div className={ el('project') }>
                    <Project/>
                </div>
                <div className={ el('feedback-form') }>
                    <FrontFeedbackFormBlock/>
                </div>
                <div className={ el('consultations') }>
                    <Consultations/>
                </div>
                <div className={ el('specialists') }>
                    <Specialists/>
                </div>
                <div className={ el('shop') }>
                    <Shop />
                </div>
                <div className={ el('mediatek') }>
                    <Mediatek />
                </div>
            </div>
        </div>
    )
}

export default Front;
